import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from "../../service/auth.service";
import {Role, UserRoles} from "../model/intefaces/UserRoles";
import {ToastController} from "@ionic/angular";

@Injectable({
  providedIn: 'root'
})
export class ModulesGuard implements CanActivate {

  constructor(private router: Router, private authService: AuthService, public toastController: ToastController,
  ) {

  }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
    const res: UserRoles = await this.authService.getModulesByUser();
    const roles: Role[] = res.roles;
    const idAdmin = roles.some(role => role.route === 'ADMIN');
    if (idAdmin) {
      return true;
    }
    const result = roles.some(role => role.route === state.url);
    if (!result) {
      await this.presentToast();
      await this.router.navigate(['/main']);
    }
    return result;
  }

  async presentToast() {
    const toast = await this.toastController.create({
      message: 'No tienes acceso a este módulo. Por favor, solicita acceso al administrador.',
      duration: 3000,
      position: 'top',
      mode: 'ios',
      color: 'dark'
    });
    await toast.present();
  }

}
